/**
 * Front Chat feature auto-registration and exports
 *
 * This module automatically registers the front chat feature when imported,
 * making it work seamlessly with both static and dynamic imports.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { frontChatFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(frontChatFeature);

// Export store (all store-related exports)
export * from './store';

// Export components
export { FrontChat } from './components';

// Export hooks
export { useFrontChatControl, useLauncherPosition } from './hooks';

// Export types (excluding those already exported from store)
export type {} from './types';
